module.exports = __webpack_public_path__ + "static/media/sura-thumbsup.956fdbd8.svg";